<template>
    <div class="perheader">
        <!--<div class="photo" :style="{backgroundImage:'url('+user_photo+')'}">-->
        <div class="photo">
        </div>
        <div class="content">
            <div class="name">
                <span>您好，{{nick}}</span><br>
            </div>
            <div class="admin">
                <span class="account">登录账号：{{userid}}</span>
                <span class="time">上次登录时间：{{lasttime}}</span>

            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";

    export default {
        name: "perheader",
        data() {
            return {
                nick:window.localStorage.nick,
                userid:window.localStorage.userid,
                lasttime:"",
                user_photo:"../assets/powerbee.png",
            }
        },
        mounted: function () {
            this.$http.get(`${store.state.url}zone/lastlogin?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                .then((res) => {
                    if (res.Code == 0) {
                        this.lasttime=res.Data;
                    } else {
                        this.$message(res.Message);
                    }
                });

            //获取头像
            // this.$http.get(`${store.state.url}user/avatar/${window.localStorage.uid}/${window.localStorage.avatarpath}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
            //     .then((res) => {
            //         if (res.Code == 0) {
            //             this.user_photo=res.Data;
            //         } else {
            //             this.$message(res.Message);
            //         }
            //     })
        },
    }
</script>

<style scoped>
    .perheader{
        heitht:20%;
        width:70%;
        display: flex;
        align-items:center;
    }
    .photo{
        width:1rem;
        height:1rem;
        /*border: 1px solid #cdcdcd;*/
        text-align: center;
        background-image: url("../assets/photo1.jpg");
        background-size:1rem 1rem;
        border-radius: 50%;
    }
    .content{
        width:100%;
    }
    .name{
        padding:0.05rem;
        border-bottom: 1px solid #409EFF;
    }
    .admin{
        padding:0.05rem;
    }
    span{
        font-size:0.18rem;
        padding:0.05rem 0.2rem;
    }
    .account{
        padding-right: 0.6rem ;
        border-right:1px solid #409EFF;
    }
    .time{
        padding-left:0.6rem;
    }
</style>